import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '../../../utils/services/api.service';
import { Organization } from '../../../utils/objects/organization';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit {

  public organization: Organization;
  
  users = [];
  organizationID;
  userControl=new FormControl();
  userId;
  username;
  attempt;

  constructor(private apiService: ApiService, private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.organizationID = this.activatedRoute.parent.snapshot.params.id;

    this.getUsers();
    this.userControl.valueChanges.subscribe(res=>{
      console.log(res)
      if(res[0]){
        this.userId=res[0].id;
        this.username=res[0].username;
        this.attempt=res[0].attempt;
      }
     
    })
  }

  getUsers() {
    
  }

  resetPassword(){
    this.apiService.resetPassword(this.organizationID,this.userId).subscribe(res=>{
      if(res.data){
        console.log('true');
      }
    })
  }

}



// WEBPACK FOOTER //
// /var/www/bizisystem-frontend/src/src/app/main/frames/users/users.component.ts